import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-disclaimerFR',
  templateUrl: '../../../assets/html/disclaimerFR.html',
  styleUrls: ['./disclaimerFR.component.css']
})
export class DisclaimerFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
